module.exports = __webpack_public_path__ + "img/1_030.850dc2bb.jpg";